import { DateTime } from 'luxon';

export const createdAtDateFilter = (date: string) => {
  return DateTime.fromISO(date).toFormat('HH:mm - dd.MM.yyyy');
};

export const priceFormat = (price: number) => {
  return parseFloat((price! / 100).toString()).toFixed(2);
};
